import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The main drivers of food insecurity in 2019 were conflict, weather extremes and economic turbulence, all of which continued to erode livelihoods and destroy lives. Conflict remained the key factor, with more than half of those facing acute hunger living in areas affected by violence and insecurity.`}</p>
    <p>{`In 2020, these primary causes of hunger have been compounded by the outbreak of COVID-19, which has been affecting people’s livelihoods as well as markets and supply chains that determine their income. As they battle the COVID-19 pandemic, poor countries risk finding themselves forced to make the trade-off between saving lives or livelihoods.`}</p>
    <p>{`These findings are a powerful call for strengthened cooperation and a global, coordinated response to the food crises we face today. WFP and the other authors behind the Global Report on Food Crises remain committed to continue helping the most vulnerable people around the world who suffer from hunger and malnutrition.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      